import { render, staticRenderFns } from "./SellBusinessAdd.vue?vue&type=template&id=cbc2dcca&scoped=true&"
import script from "./SellBusinessAdd.vue?vue&type=script&lang=js&"
export * from "./SellBusinessAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc2dcca",
  null
  
)

export default component.exports